<ng-container *ngIf="dialog$ | async as dialog">
    <div *ngIf="isShowMainTitle" class="modal-header justify-content-center" style="padding-top: 35px;">
      <div class="headline-6">{{title}}</div>
    </div>
    <div [formGroup]="formGroup" class="modal-body modal-body--survey" style="padding: 10px 40px;">
        <ng-container *ngIf="activeScreen == 'first'">
          <div class="d-flex justify-content-center align-items-center flex-column">     
            <ul  class="rating-list d-flex p-0">
              <li class="rating-icon d-flex flex-wrap" (click)="onRatingSelect($event)" value="0" 
                  style="
                  width: 40px;
                  height: 40px;
                  border: 1px solid #F46C5D;
                  background-color: #F46C5D;">
                <span class="text-white" style="cursor:pointer" >0</span>
              </li>
              <li class="rating-icon d-flex flex-wrap" (click)="onRatingSelect($event)" value="1"
                  style="
                  width: 40px;
                  height: 40px;
                  border: 1px solid #F46C5D;
                  background-color: #F46C5D;">
                <span class="text-white" style="cursor:pointer" >1</span>
              </li>
              <li class="rating-icon d-flex flex-wrap" (click)="onRatingSelect($event)" value="2"
                  style="
                  width: 40px;
                  height: 40px;
                  border: 1px solid #F46C5D;
                  background-color: #F46C5D;">
                <span class="text-white" style="cursor:pointer" >2</span>
              </li>
              <li class="rating-icon d-flex flex-wrap" (click)="onRatingSelect($event)" value="3"
                  style="
                  width: 40px;
                  height: 40px;
                  border: 1px solid #F46C5D;
                  background-color: #F46C5D;">
                <span class="text-white" style="cursor:pointer" >3</span>
              </li>
              <li class="rating-icon d-flex flex-wrap" (click)="onRatingSelect($event)" value="4"
                  style="
                  width: 40px;
                  height: 40px;
                  border: 1px solid #F46C5D;
                  background-color: #F46C5D;">
                <span class="text-white" style="cursor:pointer" >4</span>
              </li>
              <li class="rating-icon d-flex flex-wrap" (click)="onRatingSelect($event)" value="5"
                  style="
                  width: 40px;
                  height: 40px;
                  border: 1px solid #F46C5D;
                  background-color: #F46C5D;">
                <span class="text-white" style="cursor:pointer" >5</span>
              </li>
              <li class="rating-icon d-flex flex-wrap" (click)="onRatingSelect($event)" value="6"
                  style="
                  width: 40px;
                  height: 40px;
                  border: 1px solid #FFC93A;
                  background-color: #FFC93A;">
                <span class="text-white" style="cursor:pointer" >6</span>
              </li>
              <li class="rating-icon d-flex flex-wrap" (click)="onRatingSelect($event)" value="7"
                  style="
                  width: 40px;
                  height: 40px;
                  border: 1px solid #FFC93A;
                  background-color: #FFC93A;">
                <span class="text-white" style="cursor:pointer" >7</span>
              </li>
              <li class="rating-icon d-flex flex-wrap" (click)="onRatingSelect($event)" value="8"
                  style="
                  width: 40px;
                  height: 40px;
                  border: 1px solid #36C965;
                  background-color: #36C965;">
                <span class="text-white" style="cursor:pointer" >8</span>
              </li>
              <li class="rating-icon d-flex flex-wrap" (click)="onRatingSelect($event)" value="9"
                  style="
                  width: 40px;
                  height: 40px;
                  border: 1px solid #36C965;
                  background-color: #36C965;">
                <span class="text-white" style="cursor:pointer" >9</span>
              </li>
              <li class="rating-icon d-flex flex-wrap mr-0" (click)="onRatingSelect($event)" value="10"
                  style="
                  width: 40px;
                  height: 40px;
                  border: 1px solid #36C965;
                  background-color: #36C965;">
                <span class="text-white" style="cursor:pointer" >10</span>
              </li>
            </ul>
            <div class="d-flex justify-content-between w-100">
              <p  style="margin: 0;" class="mt-2 subtitle-1"><img src="images/smile_negative.png" style="height: 30px;width:30px;margin-top: -5px;"> 0 - Not likely</p>
              <p  style="margin: 0;" class="mt-2 subtitle-1"> 10 - Very Likely <img src="images/smile_positive.png" style="height: 30px;width:30px;margin-top: -5px;"></p>
            </div>
  
          </div>
            <div class="modal-header justify-content-center">
              <div class="subtitle-1">{{surveySubtitle}}</div>
            </div>
            <mdb-form-control class="form-fill textarea-control textarea-control--survey  textarea-control--paybee mb-0" style="border: 1px solid #d7d7d7;" >
              <textarea mdbInput class="form-control" formControlName="surveyFeedback" id="textAreaSurvey" rows="4"></textarea>
              <label mdbLabel class="form-label mt-4" for="textAreaSurvey">{{textAreaLadel}}</label>
          </mdb-form-control>
        </ng-container>

        <ng-container *ngIf="activeScreen == 'second'">
          <ng-container *ngIf="orgUser$ | async as user">
            <p class="subtitle-2 mb-0">Contact Email</p>
            <mdb-form-control class="form-fill form-survey form-outline mb-2">
              <app-mdbp-input #name mdbInput formControlName="email" type="email" [showMaxLength]="false" label=''></app-mdbp-input>
              <mdb-error class="form-fill-error"  *ngIf="formGroup.controls.email.hasError('incorrect') && formGroup.controls.email.touched ">Incorrect Email</mdb-error>
            </mdb-form-control>
            <p class="caption" style="color:#555454">Edit if you prefer a different email address.</p>
          </ng-container>
        </ng-container>

        <ng-container *ngIf="activeScreen == 'third'">
          <div class="d-flex justify-content-center align-items-center flex-column">
            <img src="images/launch_graphic@2x.png" class="mb-3" style="width: 200px;margin-top: -20px;">
            <div class="headline-6 mb-2" style="color: #555454;margin-top: -45px;">Feedback Sent!</div>
            <div class="body-2" style="color: #555454;">
              Thank you for helping improve PayBee! 
              We really appreciate your feedback.  
            </div>
            <div *ngIf="agreeToContact" class="text-center body-2" style="color: #555454;">A PayBee representative will reach out to you soon.</div>
          </div>
        </ng-container>

    </div>
    <ng-container *ngIf="activeScreen == 'first'">
        <div [formGroup]="formGroup" class="modal-footer d-flex paybee-modal-footer" style="background-color: inherit;">
          <app-actions-popover-survey formControlName="surveySkip" ></app-actions-popover-survey>
          <button id="survey-submit" disabled class="btn btn-sm modal-success-button waves-effect waves-light ml-3 survey-submit-button" (click)="onSubmit()">Submit</button>
        </div>  
    </ng-container>

    <ng-container *ngIf="activeScreen == 'second'">
        <div class="modal-footer d-flex paybee-modal-footer pt-0" style="background-color: inherit;">
            <button class="modal-outline-button-new survey-skip-button mr-3" (click)="onFeedback(false)">No</button>
            <button class="survey-submit-button" (click)="onFeedback(true)">Sure</button>
        </div>  
    </ng-container>
    <ng-container *ngIf="activeScreen == 'third'">
      <div class="modal-footer d-flex paybee-modal-footer" style="background-color: inherit;">
          <button class="modal-outline-button-new survey-skip-button" (click)='onClose("modal")'>Close</button>
      </div>  
  </ng-container>
</ng-container>